module.exports = __webpack_public_path__ + "img/microscope.853c2f03.svg";